export function exhaustiveCheck(value: never, context = 'Unexpected case'): never {
  throw new Error(`${context}: ${String(value)}`)
}
